import { countries } from './countries';
export const CellulantWithdrawalBanks = [
    { label: 'Sterling Bank', value: '000001', country: countries.ng.value },
    { label: 'Keystone Bank', value: '000002', country: countries.ng.value },
    { label: 'FCMB', value: '000003', country: countries.ng.value },
    { label: 'United Bank for Africa', value: '000004', country: countries.ng.value },
    { label: 'Diamond Bank', value: '000005', country: countries.ng.value },
    { label: 'JAIZ Bank', value: '000006', country: countries.ng.value },
    { label: 'Fidelity Bank', value: '000007', country: countries.ng.value },
    { label: 'Skye Bank', value: '000008', country: countries.ng.value },
    { label: 'Citi Bank', value: '000009', country: countries.ng.value },
    { label: 'Ecobank Bank', value: '000010', country: countries.ng.value },
    { label: 'Unity Bank', value: '000011', country: countries.ng.value },
    { label: 'StanbicIBTC Bank', value: '000012', country: countries.ng.value },
    { label: 'GTBank Plc', value: '000013', country: countries.ng.value },
    { label: 'Access Bank', value: '000014', country: countries.ng.value },
    { label: 'Zenith Bank', value: '000015', country: countries.ng.value },
    { label: 'First Bank of Nigeria', value: '000016', country: countries.ng.value },
    { label: 'Wema Bank', value: '000017', country: countries.ng.value },
    { label: 'Union Bank', value: '000018', country: countries.ng.value },
    { label: 'Enterprise Bank', value: '000019', country: countries.ng.value },
    { label: 'Heritage', value: '000020', country: countries.ng.value },
    { label: 'StandardChartered', value: '000021', country: countries.ng.value },
    { label: 'Suntrust', value: '000022', country: countries.ng.value },
    { label: 'Providus', value: '000023', country: countries.ng.value },
    { label: 'Coronation Merchant Bank', value: '060001', country: countries.ng.value },
    { label: 'NPF Microfinance Bank', value: '070001', country: countries.ng.value },
    { label: 'Fortis Microfinance Bank', value: '070002', country: countries.ng.value },
    { label: 'Covenant', value: '070006', country: countries.ng.value },
    { label: 'ASOSavings', value: '090001', country: countries.ng.value },
    { label: 'JubileeLife', value: '090003', country: countries.ng.value },
    { label: 'Parralex', value: '090004', country: countries.ng.value },
    { label: 'Trustbond', value: '090005', country: countries.ng.value },
    { label: 'Safetrust Mortgage bank', value: '090006', country: countries.ng.value },
    { label: 'FET', value: '100001', country: countries.ng.value },
    { label: 'Pagatech', value: '100002', country: countries.ng.value },
    { label: 'Parkway-ReadyCash', value: '100003', country: countries.ng.value },
    { label: 'Paycom', value: '100004', country: countries.ng.value },
    { label: 'Cellulant', value: '100005', country: countries.ng.value },
    { label: 'eTranzact', value: '100006', country: countries.ng.value },
    { label: 'StanbicMobileMoney', value: '100007', country: countries.ng.value },
    { label: 'EcoMobile', value: '100008', country: countries.ng.value },
    { label: 'GTMobile', value: '100009', country: countries.ng.value },
    { label: 'TeasyMobile', value: '100010', country: countries.ng.value },
    { label: 'Mkudi', value: '100011', country: countries.ng.value },
    { label: 'VTNetworks', value: '100012', country: countries.ng.value },
    { label: 'AccessMobile', value: '100013', country: countries.ng.value },
    { label: 'FBNMobile', value: '100014', country: countries.ng.value },
    { label: 'ChamsMobile', value: '100015', country: countries.ng.value },
    { label: 'FortisMobile', value: '100016', country: countries.ng.value },
    { label: 'Hedonmark', value: '100017', country: countries.ng.value },
    { label: 'ZenithMobile', value: '100018', country: countries.ng.value },
    { label: 'Fidelity Mobile', value: '100019', country: countries.ng.value },
    { label: 'MoneyBox', value: '100020', country: countries.ng.value },
    { label: 'Eartholeum', value: '100021', country: countries.ng.value },
    { label: 'FSDH', value: '400001', country: countries.ng.value },
    { label: 'NIP Virtual Ban', value: '999999', country: countries.ng.value },
    { label: 'KCB', value: '0001', country: countries.ke.value },
    { label: 'Stanchart', value: '0002', country: countries.ke.value },
    { label: 'ABSA', value: '0003', country: countries.ke.value },
    { label: 'Bank of India', value: '0005', country: countries.ke.value },
    { label: 'Bank of Baroda', value: '0006', country: countries.ke.value },
    { label: 'NCBA', value: '0007', country: countries.ke.value },
    { label: 'Prime Bank', value: '0010', country: countries.ke.value },
    { label: 'Coop Bank', value: '0011', country: countries.ke.value },
    { label: 'NBK', value: '0012', country: countries.ke.value },
    { label: 'M-Oriental', value: '0014', country: countries.ke.value },
    { label: 'Citi Bank', value: '0016', country: countries.ke.value },
    { label: 'Habib Bank AG Zurich', value: '0017', country: countries.ke.value },
    { label: 'Middle East Bank', value: '0018', country: countries.ke.value },
    { label: 'Bank of Africa', value: '0019', country: countries.ke.value },
    { label: 'Consolidated', value: '0023', country: countries.ke.value },
    { label: 'Credit Bank', value: '0025', country: countries.ke.value },
    { label: 'Access Bank', value: '0026', country: countries.ke.value },
    { label: 'Chase Bank', value: '0030', country: countries.ke.value },
    { label: 'Stanbic Bank', value: '0031', country: countries.ke.value },
    { label: 'ABC Bank', value: '0035', country: countries.ke.value },
    { label: 'Eco Bank', value: '0043', country: countries.ke.value },
    { label: 'Equatorial Commercial Bank', value: '0049', country: countries.ke.value },
    { label: 'Paramount', value: '0050', country: countries.ke.value },
    { label: 'Kingdom Bank', value: '0051', country: countries.ke.value },
    { label: 'Gt Bank', value: '0053', country: countries.ke.value },
    { label: 'Victoria Bank', value: '0054', country: countries.ke.value },
    { label: 'Guardian Bank', value: '0055', country: countries.ke.value },
    { label: 'I&M Bank', value: '0057', country: countries.ke.value },
    { label: 'Development Bank', value: '0059', country: countries.ke.value },
    { label: 'SBM', value: '0060', country: countries.ke.value },
    { label: 'Housing finance', value: '0061', country: countries.ke.value },
    { label: 'DTB', value: '0063', country: countries.ke.value },
    { label: 'Mayfair Bank', value: '0065', country: countries.ke.value },
    { label: 'Sidian Bank', value: '0066', country: countries.ke.value },
    { label: 'Equity Bank', value: '0068', country: countries.ke.value },
    { label: 'Family Bank', value: '0070', country: countries.ke.value },
    { label: 'Gulf African Bank', value: '0072', country: countries.ke.value },
    { label: 'First Community Bank', value: '0074', country: countries.ke.value },
    { label: 'DIB Bank', value: '0075', country: countries.ke.value },
    { label: 'UBA', value: '0076', country: countries.ke.value },
    { label: 'KWFT', value: '0078', country: countries.ke.value },
    { label: 'Faulu Bank', value: '0079', country: countries.ke.value },
    { label: 'Post Bank', value: '0099', country: countries.ke.value },
    { label: 'IPS (Instant Payment Switch)', value: '9999', country: countries.ke.value },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
export const CellulantWithdrawalProviders = [
    { value: 'KE-SAFARICOM-B2C', label: 'SAFARICOM', country: countries.ke.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'KE-AIRTEL-DISBURSEMENT', label: 'AIRTEL', country: countries.ke.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'TZ-VODACOM-B2C', label: 'VODACOM', country: countries.tz.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'TZ-AIRTEL-B2C', label: 'AIRTEL', country: countries.tz.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'TZ-TIGO-B2C', label: 'TIGO', country: countries.tz.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'UG-AIRTEL-C2B', label: 'AIRTEL', country: countries.ug.value, category: 'MOBILE MONEY (C2B STK' },
    { value: 'UG-AFRICELL-C2B', label: 'AFRICELL', country: countries.ug.value, category: 'MOBILE MONEY (C2B STK' },
    { value: 'ZW-TELECASH-B2C', label: 'TELECASH', country: countries.zw.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'ZW-ECOCASH-B2C', label: 'ECOCASH', country: countries.zw.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'ZM-MTN-B2C', label: 'MTN', country: countries.zm.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'ZM-AIRTEL-B2C', label: 'AIRTEL', country: countries.zm.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'ZM-ZAMTEL-B2C', label: 'ZAMTEL', country: countries.zm.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'GH-MTN-B2C', label: 'MTN', country: countries.gh.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'GH-AIRTEL-B2C', label: 'TIGO & AIRTEL', country: countries.gh.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'GH-VODAFONE-B2C', label: 'VODAFONE', country: countries.gh.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'CI-ORANGE-B2C', label: 'ORANGE', country: countries.ci.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'CI-MTN-B2C', label: 'MTN', country: countries.ci.value, category: 'MOBILE MONEY (B2C)' },
    { value: 'CI-MOOV-B2C', label: 'MOOV', country: countries.ci.value, category: 'MOBILE MONEY (B2C)' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
